export * as proposalDetails from './proposal-details'
export * as proposalList from './proposal-list'
